module.exports = __webpack_public_path__ + "media/img/android-icon-96x96-6669f0025000b68151e65a90c016d24b.png";